// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OcwR","buttons":"styles_buttons__2I0GP"};